import { l as _inherits, h as _createClass, e as _extends, i as _classCallCheck, m as _callSuper } from './_rollupPluginBabelHelpers-e71b1aad.js';
import PropTypes, { imageShape } from 'prop-types';
import React__default from 'react';
import Slider from 'react-slick';
import Image from './Image.js';
import Label from './Label.js';
import { i as intlShape } from './PropTypes-e1e509ba.js';
import { d as defaultImage } from './general-2a8d8650.js';
import { F as FormattedMessage } from './message-f222f616.js';
import './Modal.js';
import 'react-dom';
import './ModalHeader-77a50105.js';
import './index-11bc5ac3.js';
import './_commonjsHelpers-17042db9.js';
import './Title.js';
import './tslib.es6-2748fcb6.js';
import 'moment';
import './useIntl-2a91ee7b.js';
import './injectIntl-d3879c1a.js';
import './hoist-non-react-statics.cjs-50d12f04.js';
import './index-f5c6df27.js';

var PhotoGallery = /*#__PURE__*/function (_React$Component) {
  function PhotoGallery(props) {
    var _this;
    _classCallCheck(this, PhotoGallery);
    _this = _callSuper(this, PhotoGallery, [props]);
    _this.state = {
      photos: null,
      thumbnails: null
    };
    _this.positionThumbnails = 1;
    _this.initializedPhotos = false;
    _this.initializedThumbnails = false;
    _this.setPhotos = _this.setPhotos.bind(_this);
    _this.setThumbnails = _this.setThumbnails.bind(_this);
    _this.handleImageError = _this.handleImageError.bind(_this);
    return _this;
  }
  _inherits(PhotoGallery, _React$Component);
  return _createClass(PhotoGallery, [{
    key: "setPhotos",
    value: function setPhotos(photos) {
      if (!this.initializedPhotos) {
        this.setState({
          photos: photos
        });
        this.initializedPhotos = true;
      }
    }
  }, {
    key: "setThumbnails",
    value: function setThumbnails(thumbnails) {
      if (!this.initializedThumbnails) {
        this.setState({
          thumbnails: thumbnails
        });
        this.initializedThumbnails = true;
      }
    }
  }, {
    key: "handleImageError",
    value: function handleImageError(imageElement) {
      imageElement.target.src = defaultImage;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        images = _this$props.images,
        marketing = _this$props.marketing,
        thumbsEnabled = _this$props.thumbsEnabled,
        slidesToShow = _this$props.slidesToShow,
        intl = _this$props.intl,
        photoKeyPrefix = _this$props.photoKeyPrefix,
        thumbKeyPrefix = _this$props.thumbKeyPrefix,
        adaptiveHeight = _this$props.adaptiveHeight,
        hasUncroppedImages = _this$props.hasUncroppedImages;
      var _this$state = this.state,
        thumbnails = _this$state.thumbnails,
        photos = _this$state.photos;
      var GalleryThumbnails = thumbsEnabled ? thumbnails : false;
      var removeCloneThumbs = "gallery-thumbnails-wrapper ".concat(images.length < slidesToShow ? 'remove-clone-thumbs' : '');
      var imageMarketing = null;
      if (marketing) {
        if (marketing.mealPlan) {
          imageMarketing = {
            color: 'orange',
            content: marketing.mealPlan,
            ribbonLeft: true
          };
          return;
        }
        if (marketing.promotion) {
          imageMarketing = {
            color: 'yellow',
            content: /*#__PURE__*/React__default.createElement(FormattedMessage, {
              id: "bf.sale",
              defaultMessage: "bf.sale"
            }),
            ribbonLeft: true
          };
        }
      }
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, imageMarketing ? /*#__PURE__*/React__default.createElement(Label, _extends({
        className: "gallery-ribbon"
      }, imageMarketing)) : null, /*#__PURE__*/React__default.createElement(Slider, {
        asNavFor: GalleryThumbnails,
        adaptiveHeight: adaptiveHeight,
        ref: this.setPhotos,
        key: "ROOMS_DETAILS_GALLERY",
        className: "gallery-active-image-wrapper",
        lazyLoad: "progressive",
        fade: true,
        infinite: true
      }, images ? images.map(function (image, index) {
        var keyName = "".concat(photoKeyPrefix).concat(index);
        var altText = image.description || intl.formatMessage({
          id: 'bf.imagePreview',
          defaultMessage: 'bf.imagePreview'
        });
        return (
          /*#__PURE__*/
          // TODO @Milo (48536 - EU images) - in the rendered html, same url and alt text is displayed
          // but image itslef is changed...
          React__default.createElement(Image, {
            key: keyName,
            mainImage: {
              title: keyName,
              url: image.url ? image.url : defaultImage
            },
            onError: _this2.handleImageError,
            fluid: true,
            className: hasUncroppedImages ? 'has-not-cropped-image' : '',
            alt: altText
          })
        );
      }) : null), thumbsEnabled && images.length > 1 ? /*#__PURE__*/React__default.createElement(Slider, {
        key: "ROOMS_DETAILS_GALLERY_THUMBS",
        asNavFor: photos,
        ref: this.setThumbnails,
        slidesToShow: images.length > 3 ? 3 : images.length,
        slidesToScroll: this.positionThumbnails,
        centerMode: true,
        swipeToSlide: true,
        focusOnSelect: true,
        infinite: true,
        className: removeCloneThumbs
      }, images ? images.map(function (image, index) {
        var keyName = "".concat(thumbKeyPrefix).concat(index);
        var altText = image.description || intl.formatMessage({
          id: 'bf.displayImagePreview',
          defaultMessage: 'bf.displayImagePreview'
        });
        return /*#__PURE__*/React__default.createElement(Image, {
          key: keyName,
          mainImage: {
            title: keyName,
            url: image.url ? image.url : defaultImage
          },
          onError: _this2.handleImageError,
          fluid: true,
          className: hasUncroppedImages ? 'has-not-cropped-image' : '',
          alt: altText
        });
      }) : null) : null);
    }
  }]);
}(React__default.Component);
PhotoGallery.defaultProps = {
  images: [{
    url: defaultImage
  }],
  thumbsEnabled: false,
  slidesToShow: 5,
  photoKeyPrefix: 'PHOTO_',
  thumbKeyPrefix: 'THUMB_',
  adaptiveHeight: false,
  marketing: null,
  hasUncroppedImages: false
};
PhotoGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape(imageShape)),
  thumbsEnabled: PropTypes.bool,
  slidesToShow: PropTypes.number,
  photoKeyPrefix: PropTypes.string,
  thumbKeyPrefix: PropTypes.string,
  adaptiveHeight: PropTypes.bool,
  marketing: PropTypes.shape({
    mealPlan: PropTypes.string,
    promotion: PropTypes.string
  }),
  hasUncroppedImages: PropTypes.bool,
  intl: PropTypes.shape(intlShape).isRequired
};

export default PhotoGallery;
//# sourceMappingURL=PhotoGallery.js.map
